var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-view"},[_c(_vm.currentComponent,{tag:"component",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }